import OVideoShopGridItem from './o-videoshop-grid-item';

export default OVideoShopGridItem;